import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, MenuItem, Stack, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import API from "../../../services/API";

const currentYear = parseInt(new Date().getFullYear());

const currentMonth = parseInt(new Date().getMonth()) + 1;

const months = ['', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

const width = window.innerWidth > 600 ? 500 : 280;

export default function ExportModal({open, onClose}){

    const [year, setYear] = useState(currentYear)

    const [month, setMonth] = useState(currentMonth)

    const [from, setFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'))

    const [to, setTo] = useState(moment().format('YYYY-MM-DD'))

    const [download, setDownload] = useState(false)

    const [error, setError] = useState(false)

    const start = key => {
        setError(false)
        setDownload(key)
    }

    const stop = () => setDownload(false)

    const handleClick = ext => {

        start(ext)

        const name = `factures_${year}_${String(month).padStart(2, '0')}.${ext}`;

        API.download(`/orders/${year}/${month}/invoices.${ext}`, name)
            .catch(_ => setError(true))
            .finally(stop)
    }

    const handleRangeClick = () => {

        start('range')

        const name = `factures_${from}_${to}.csv`;

        API.download(`/orders/invoices.csv?from=${from}&to=${to}`, name)
            .catch(_ => setError(true))
            .finally(stop)
    }

    const rangeIsValid = from && to && from <= to;

    return <Dialog open={open} onClose={onClose}>

        <DialogTitle>Exporter des factures</DialogTitle>

        <DialogContent>

            <Stack spacing={2} sx={{minWidth: width, mt: 1}}>

                <TextField
                    select 
                    label="Année"
                    required
                    size='small'
                    value={year}
                    onChange={e => setYear(parseInt(e.target.value))}
                >
                    {[0,1,2,3,4,5,6,7,8,9,10].map(y =>
                        <MenuItem key={y} value={currentYear - y}>
                            {currentYear - y}
                        </MenuItem>    
                    )}
                </TextField>

                <TextField
                    select 
                    label="Mois"
                    required
                    size='small'
                    value={month}
                    onChange={e => setMonth(parseInt(e.target.value))}
                >
                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(m =>
                        <MenuItem key={m} value={m}>
                            {months[m]}
                        </MenuItem>    
                    )}
                </TextField>

                {error && 
                    <Alert severity='error'>
                        Une erreur s'est produite.
                    </Alert>
                }

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'pdf'}
                    disabled={download !== false}
                    onClick={() => handleClick('pdf')}
                >
                    Exporter en PDF
                </LoadingButton>

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'csv'}
                    disabled={download !== false}
                    onClick={() => handleClick('csv')}
                >
                    Exporter en CSV
                </LoadingButton>

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'zip'}
                    disabled={download !== false}
                    onClick={() => handleClick('zip')}
                >
                    Exporter le ZIP
                </LoadingButton>

                <Alert severity='info'>
                    Attention : l'export peut prendre quelques minutes.
                </Alert>

                <Divider />

                <Typography variant='subtitle2'>
                    Exporter la liste sur une période
                </Typography>

                <TextField
                    label="Du"
                    type='date'
                    required
                    size='small'
                    value={from}
                    onChange={e => setFrom(e.target.value)}
                    InputLabelProps={{shrink: true}}
                />

                <TextField
                    label="Au"
                    type='date'
                    required
                    size='small'
                    value={to}
                    onChange={e => setTo(e.target.value)}
                    InputLabelProps={{shrink: true}}
                />

                <LoadingButton 
                    startIcon={<Download />}
                    loading={download === 'range'}
                    disabled={download !== false || !rangeIsValid}
                    onClick={handleRangeClick}
                >
                    Exporter la liste en CSV
                </LoadingButton>

            </Stack>

        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Annuler</Button>
        </DialogActions>

    </Dialog>

}
